import React from 'react';
import { Dropdown as AntdDropdown, Space } from 'antd';
import Button from '../button/Button';

//Refactor this component more to accept generic dropdown button else show default button
const Dropdown = ({
  items,
  style,
  onClick,
  defaultBtnSize = 'medium',
  triggerMode = ['click'],
  placement = 'bottomRight',
  onVisibleChange = () => {},
  dropdownButtonStyle = {},
  DropDownButton,
  visible,
  ...rest
}) => (
  <AntdDropdown
    menu={{
      items,
    }}
    style={style}
    trigger={triggerMode}
    placement={placement}
    onOpenChange={onVisibleChange}
    {...(visible !== undefined && { open: visible })}
    {...rest}
  >
    <div style={{ cursor: 'pointer', ...dropdownButtonStyle }} onClick={onClick}>
      {DropDownButton && <DropDownButton onClick={(e) => e.preventDefault()} />}
    </div>
  </AntdDropdown>
);
export default Dropdown;
